export type VariableSnippet = {
  before: string;
  placeholder: string;
  after: string;
  fullSnippet: string;
};

/**
 * Extracts a readable surrounding snippet of text around a template variable (e.g. `{{1}}`).
 */
export function getVariableSnippet(
  bodyText: string | null | undefined,
  variableNumber: number,
  radius = 30
): VariableSnippet | null {
  if (!bodyText || typeof bodyText !== "string") return null;

  const placeholder = `{{${variableNumber}}}`;
  const idx = bodyText.indexOf(placeholder);
  if (idx === -1) return null;

  const start = Math.max(0, idx - radius);
  const end = Math.min(bodyText.length, idx + placeholder.length + radius);

  const beforeRaw = bodyText.slice(start, idx).replace(/\s+/g, " ");
  const afterRaw = bodyText.slice(idx + placeholder.length, end).replace(/\s+/g, " ");

  const before = start > 0 ? `...${beforeRaw.trimStart()}` : beforeRaw;
  const after = end < bodyText.length ? `${afterRaw.trimEnd()}...` : afterRaw;

  return {
    before,
    placeholder,
    after,
    fullSnippet: `"${before}${placeholder}${after}"`,
  };
}
